const styles = (theme) => ({
  additionalPadding: {
    paddingTop: '60px',
  },
  eventYear: {
    fontSize: '28px',
    fontWeight: 600,
    textAlign: 'center',
    padding: '44px 0',
    color: theme.palette.primary.main,
  },
  emptyList: {
    textAlign: 'center',
    padding: '20px 0 40px',
  },
});

export default styles;
